module.exports = __webpack_public_path__ + "static/media/check.6394943e.svg";